import { render, staticRenderFns } from "./MediaReacordList.vue?vue&type=template&id=1bb6c902&scoped=true"
import script from "./MediaReacordList.vue?vue&type=script&lang=js"
export * from "./MediaReacordList.vue?vue&type=script&lang=js"
import style0 from "./MediaReacordList.vue?vue&type=style&index=0&id=1bb6c902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb6c902",
  null
  
)

export default component.exports